// eslint-disable-next-line
import { TestIamPermissionsRequest } from "@xboxstudios/hermes-apis/xboxstudios/hermes/iam/v1/iam_policy_pb";

// These permissions are defined in the Hermes service source code
const makePerms = (serviceName: string, resourceType: string) => {
  return {
    Get: `${serviceName}.${resourceType}s.get`,
    List: `${serviceName}.${resourceType}s.list`,
    Update: `${serviceName}.${resourceType}s.update`,
    Delete: `${serviceName}.${resourceType}s.delete`,
    Undelete: `${serviceName}.${resourceType}s.undelete`,
    GetIamPolicy: `${serviceName}.${resourceType}s.getIamPolicy`,
    SetIamPolicy: `${serviceName}.${resourceType}s.setIamPolicy`,
  };
};

export type Permissions = ReturnType<typeof makePerms>;

/** Permissions are used to check a user's ability to
 * perform a specific action via {@link TestIamPermissionsRequest}
 */
export const HermesPermissions = {
  Device: makePerms("device", "device"),
  Product: {
    Product: makePerms("product", "product"),
    Version: makePerms("product", "version"),
    Channel: makePerms("product", "channel"),
  },
  ChunkStore: {
    Depot: makePerms("chunkstore", "depot"),
    Archive: makePerms("chunkstore", "archive"),
  },
  Directory: {
    Organization: makePerms("directory", "organization"),
  },
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type HermesPermission = typeof HermesPermissions;
